import ExcelJS from 'exceljs'
import { saveAs } from 'file-saver'
import moment from 'moment'
import { numberFormat } from 'utils/app.utils'

async function ExportToExcel({
    data,
    filter,
    t,
}: {
    data: any
    filter: any[]
    t: any
}) {
    const workbook = new ExcelJS.Workbook()
    const sheet = workbook.addWorksheet(t('REPORT.REPORT_NAME.ACCESS_CHANNEL'))

    // Title
    sheet.addRow([t('REPORT.REPORT_NAME.ACCESS_CHANNEL')])
    sheet.addRow([])
    // Filter info (horizontal)
    sheet.addRow([
        t('REPORT.FILTER.BRANCH'), filter[1],
        t('REPORT.FILTER.DATE_START'), filter[2],
        t('REPORT.FILTER.DATE_END'), filter[3],
    ])
    sheet.addRow([])
    // Table header
    const headCells = [
        { id: 'no', label: t('REPORT.TABLE.ACCESS_CHANNEL.#NO'), align: 'left' },
        { id: 'access_channel', label: t('REPORT.TABLE.ACCESS_CHANNEL.ACCESS_CHANNEL'), align: 'left' },
        { id: 'count', label: t('REPORT.TABLE.ACCESS_CHANNEL.COUNT'), align: 'center' },
    ]
    sheet.addRow(headCells.map(h => h.label))

    // Table rows
    data.rows.forEach((row: any, idx: number) => {
        sheet.addRow([
            idx + 1,
            row.result_channelName,
            numberFormat(row.totalCount, 0),
        ])
    })

    // Style header
    // The header is always at row 7 (after 1 title, 1 blank, 3 filter, 1 blank)
    const headerRowNumber = 5;
    const headerRow = sheet.getRow(headerRowNumber);
    headerRow.font = { bold: true };
    headerRow.alignment = { horizontal: 'center' };

    // Set column widths
    sheet.columns = [
        { width: 10 },
        { width: 40 },
        { width: 20 },
    ]

    // Save file
    const buffer = await workbook.xlsx.writeBuffer()
    saveAs(new Blob([buffer]), `${t('REPORT.REPORT_NAME.ACCESS_CHANNEL')}_${moment().format('YYYYMMDD_HHmmss')}.xlsx`)
}

export default ExportToExcel 